import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NEVER, Observable } from 'rxjs';
import { AssetSearchResult, ENVIRONMENT, MainSearchItem, TreeSearchItem } from '../models';
import { TreeService } from './tree.service';

@Injectable({ providedIn: 'root' })
export class AssetSearchService {
  private apiUrl = inject(ENVIRONMENT).apiUrl;

  constructor(
    private httpClient: HttpClient,
    private treeService: TreeService,
  ) {}

  findByText(text: string, maxRows = 3): Observable<AssetSearchResult<MainSearchItem>> {
    return this.httpClient.post<AssetSearchResult<MainSearchItem>>(this.apiUrl + '/v2/search', {
      query: text,
      offset: 0,
      pageSize: maxRows,
      sortBy: 'updated',
      sortOrder: 'DESC',
    });
  }

  searchAssetsInTree(
    searchString: string,
    rootUuid: string,
    pageSize = 10,
  ): Observable<AssetSearchResult<TreeSearchItem>> {
    const tree = this.treeService.getTreeByUuid(rootUuid);
    if (!tree) {
      return NEVER;
    }
    // In a partially shared tree the root node is visible but flagged virtual. It cannot
    // be used to start a search because the user does not have access to it, so use its
    // children instead.
    const startingAssets = tree.virtual ? tree.children.map(x => x.uuid) : [tree.uuid];
    return this.httpClient.post<AssetSearchResult<TreeSearchItem>>(this.apiUrl + '/v2/search', {
      query: searchString,
      startingAssets,
      pageSize,
      extraColumns: {
        root: true,
        parent: true,
      },
    });
  }

  searchAssetByPartNumberSerial(
    partNumber?: string,
    serialNumber?: string,
    pageSize = 10,
  ): Observable<AssetSearchResult> {
    return this.httpClient.post<AssetSearchResult>(this.apiUrl + '/v2/search', {
      partNumber,
      serialNumber,
      pageSize,
      extraColumns: { root: true },
    });
  }

  findOutdatedProducts(
    rootUuid: string,
    offset: number,
    pageSize: number,
  ): Observable<AssetSearchResult> {
    return this.httpClient.post<AssetSearchResult>(this.apiUrl + '/v2/search', {
      startingAssets: rootUuid,
      firmwareStates: ['UPDATE_AVAILABLE'],
      offset,
      pageSize,
    });
  }
}
